const FIBR_CLIENT_SDK_ID = 'fibr-jssdk'
const FIBR_INLINE_SCRIPT_ID = 'fibr-inline-loader'
const FIBR_PRECONNECT_LINK_ID = 'fibr-preconnect'
const FIBR_DNS_PREFETCH_LINK_ID = 'fibr-dns-prefetch'

export const FIBR_PRECONNECT_URL = 'https://cdn.fibr.shop'

export const FIBR_INLINE_SCRIPT = `
var cfg={hide:false,unhideMs:7500};
(function(f,i,b,r){if(cfg.hide){f.head.append(Object.assign(f.createElement("style"),{id:"fibr-async-img-style",innerHTML:"img{opacity:0}"}));f.head.append(Object.assign(f.createElement("style"),{id:"fibr-style",innerHTML:"body{opacity:0}"}));setTimeout(function(){var imgStyle=f.getElementById("fibr-async-img-style");if(imgStyle)imgStyle.innerHTML="img{opacity:1}";var bodyStyle=f.getElementById("fibr-style");if(bodyStyle&&bodyStyle.parentNode)bodyStyle.parentNode.removeChild(bodyStyle)},cfg.unhideMs)}var js,fjs=f.getElementsByTagName(i)[0];if(f.getElementById(r))return;js=f.createElement(i);js.id=r;js.src="https://cdn.fibr.shop/sdks/client/"+b+"/fpt-client-sdk.min.js";f.getElementsByTagName("head")[0].insertBefore(js,fjs)})(document,"script","69f347ae49fd34a8ac6a2e8f","${FIBR_CLIENT_SDK_ID}");
`.trim()

export {
	FIBR_CLIENT_SDK_ID,
	FIBR_DNS_PREFETCH_LINK_ID,
	FIBR_INLINE_SCRIPT_ID,
	FIBR_PRECONNECT_LINK_ID,
}
